//#region Imports

import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { Module } from '../../models/interfaces/module.interface';
import { Class } from '../../models/interfaces/module-class.interface';
import { IconComponent } from '../icon/icon.component';

//#endregion

@Component({
  selector: 'l-module-card',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './module-card.component.html',
})
export class ModuleCardComponent implements OnChanges {

  //#region Public Properties

  @Input()
  public modules: Module[] = [];

  public openModuleIds: Set<string> = new Set<string>();

  //#endregion

  //#region Public Methods

  public ngOnChanges(): void {
    if (!this.modules.length) {
      this.openModuleIds.clear();
    }
  }

  public toggleModule(moduleId: string): void {
    if (this.openModuleIds.has(moduleId)) {
      this.openModuleIds.delete(moduleId);
      return;
    }

    this.openModuleIds.add(moduleId);
  }

  public isOpen(moduleId: string): boolean {
    return this.openModuleIds.has(moduleId);
  }

  public getOrderedClasses(module: Module): Class[] {
    const classes = module.classes ?? [];
    return [...classes].sort((first, second) => first.order - second.order);
  }

  public getDurationLabel(module: Module): string {
    const totalMinutes = module.duration ?? this.getOrderedClasses(module)
      .reduce((accumulator, moduleClass) => accumulator + moduleClass.duration, 0);

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours === 0) return `${minutes}min`;
    if (minutes === 0) return `${hours}h`;
    return `${hours}h ${minutes}min`;
  }

  //#endregion

}
